import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useResetPassword } from '../api/queries';

const BACK_TO_LOGIN_MS = 2500;

/** Il reset dal link dell'email: senza token nel link non c'è modulo; dopo il reset torna al login. */
export function useResetPasswordScreen() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const resetPassword = useResetPassword();

  useEffect(() => {
    if (!resetPassword.isSuccess) return undefined;
    const timer = setTimeout(() => navigate('/login'), BACK_TO_LOGIN_MS);
    return () => clearTimeout(timer);
  }, [resetPassword.isSuccess, navigate]);

  return {
    hasToken: Boolean(token),
    submitting: resetPassword.isPending,
    error: resetPassword.error?.message,
    done: resetPassword.isSuccess,
    submit: (password: string) => resetPassword.mutate({ token, password }),
  };
}
